module.exports = __webpack_public_path__ + "static/media/slider.6e06f70c.svg";